export default __webpack_public_path__ + "fonts/nucleo-icons.ttf";